import React from "react";
import { Button } from "@mui/material";

export class ErrorBoundary extends React.PureComponent {
  state = { hasError: false, errorInfo: null };

  static getDerivedStateFromError(/*error*/) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    this.setState({
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return <>
        <div align="center">
          <h1>An error occurred.</h1>
          <pre>{JSON.stringify(this.state.errorInfo)}</pre>
          <Button variant="contained" onClick={() => window.location.assign("/projects")}>
            Back home
          </Button>
        </div>
      </>;
    }

    return this.props.children;
  }
}
